import type { AnswerWidgetRenderer } from '@openx/components-core/lib/Markdown/widgets/answerWidgetRenderer';
import type { TFunction } from 'i18next';
import type { ComponentType } from 'react';
import { OpenXAgentTargetingCopyPersonas } from './Personas/components/OpenXAgentTargetingCopyPersonas';
import { OpenXAgentPersonas } from './Personas/OpenXAgentPersonas';
import { OpenXAgentTargetingCopyChips } from './TargetingChips/components/OpenXAgentTargetingCopyChips';
import { OpenXAgentTargetingChips } from './TargetingChips/OpenXAgentTargetingChips';
import { getOpenXAgentWidgetKind, OpenXAgentWidgetKind } from './utils/openXAgentWidgetKind';

type OpenXAgentWidget = {
  View: ComponentType<{ payload: unknown }>;
  // plain HTML rather than MUI on purpose: the markup is pasted outside the app, where MUI styles don't exist
  Copy: ComponentType<{ payload: unknown; t: TFunction }>;
};

const OPENX_AGENT_WIDGETS: Record<OpenXAgentWidgetKind, OpenXAgentWidget> = {
  [OpenXAgentWidgetKind.TARGETING_CHIPS]: { View: OpenXAgentTargetingChips, Copy: OpenXAgentTargetingCopyChips },
  [OpenXAgentWidgetKind.PERSONAS]: { View: OpenXAgentPersonas, Copy: OpenXAgentTargetingCopyPersonas },
};

export const renderOpenXAgentAnswerWidget: AnswerWidgetRenderer = payload => {
  const kind = getOpenXAgentWidgetKind(payload);
  if (kind === null) return undefined;

  const { View } = OPENX_AGENT_WIDGETS[kind];
  return <View payload={payload} />;
};

// widgets are copied as plain paragraphs, so a paste reads well with or without formatting
export const createOpenXAgentAnswerWidgetClipboardRenderer =
  (t: TFunction): AnswerWidgetRenderer =>
  payload => {
    const kind = getOpenXAgentWidgetKind(payload);
    if (kind === null) return undefined;

    const { Copy } = OPENX_AGENT_WIDGETS[kind];
    return <Copy payload={payload} t={t} />;
  };
